import { useAppStore } from '@/store';
import { clearEmbedUrlSession } from './embedUrlSession';
import { clearMagicToken } from './magicToken';
import { clearResolverCache } from './tokenResolver';
import { clearAuthTokens } from './tokenStorage';

// gloss
const PREVIOUS_PERSON_KEYS = [
  'profileInfo',
  'firstName',
  'lastName',
  'userPicture',
  'user',
  'chatUserUuid',
  'myForumUserID',
];

// gloss
const AUTH0_SDK_CACHE_PREFIX = '@@auth0spajs@@';

// gloss
export const clearPreviousSignIn = (): void => {
  if (typeof window === 'undefined') return;

  clearAuthTokens();
  clearMagicToken();
  clearEmbedUrlSession();
  clearResolverCache();

  for (const key of PREVIOUS_PERSON_KEYS) window.localStorage.removeItem(key);
  for (let index = window.localStorage.length - 1; index >= 0; index -= 1) {
    const key = window.localStorage.key(index);
    if (key?.startsWith(AUTH0_SDK_CACHE_PREFIX)) window.localStorage.removeItem(key);
  }

  useAppStore.getState().currentUser.clear();
};
